// import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import {Location} from '@angular/common';
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MasterService } from "src/app/services/master.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { OrganizationResponseModel } from "src/app/model/OrganizationResponseModel";

@Component({
  selector: "app-secure-organization-au",
  templateUrl: "./organization-au.component.html",
  styleUrls: ["./organization-au.component.scss"],
})
export class OrganizationAUComponent implements OnInit {
  organizationKey: number;
  pageMode: string;
  organizationModel : OrganizationResponseModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  organizationLogoFile: File;

  constructor(
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private http: HttpClient,
    private location: Location,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    console.log("organization component on init called");
    this.route.params.subscribe((params: Params) => {
      this.organizationKey = +params["key"];
      
      if(this.organizationKey) {
        this.masterService
          .getOrgBykey(this.organizationKey)
          .subscribe((data: any) => {
            this.organizationModel = data;
            this.pageMode = "Edit";
            console.log('Form Mode Edit');
            this.form.patchValue({
              orgCode: this.organizationModel.organizationCode,
              orgName: this.organizationModel.organizationName,
              orgLogo: this.organizationModel.organizationLogoResource
            });
          });
      }
      else {
        this.pageMode = "Add";
        console.log('Form Mode Add');
      }
      this.form = new FormGroup({
        orgCode: new FormControl(null, Validators.required),
        orgName: new FormControl(null, Validators.required),
        orgLogo: new FormControl(null, Validators.required),
      });
    });
  }

  onFileSelect(event) {
    this.organizationLogoFile = event.target.files[0];
  }

  onSubmit() {
    if(this.pageMode === 'Add') {
      this.saveOrganization();
    }
    else {
      this.updateOrganization();
    }
  }

  async saveOrganization() {
    console.log(this.form.value);
    if (this.form.valid) {
      const reader = new FileReader();
      reader.readAsDataURL(this.organizationLogoFile);
      reader.onload = () => {
        console.log('file base64', reader.result);
        this.masterService
        .saveOrg({
          organizationCode: this.form.value.orgCode,
          organizationName: this.form.value.orgName,
          organizationLogoFile: reader.result
        })
        .subscribe((data: any) => {
            if(data.status === 'SUCCESS') {
              this.successToast();
              this.router.navigate(["/secure", "master", "organization", "list"]);
            }
            else {
              this.isSubmitDisabled = false;
              this.errorToast(data.errorMessage);
            }
          }, error => {
            this.isSubmitDisabled = false;
            console.log(error);
            this.errorToast(error.error.errorMessage, 5*1000);
          });
      };
    } else {
      this.isSubmitDisabled = false;
      this.errorToast("");
    }
  }


  async updateOrganization() {
    console.log(this.form.value);
    if (this.form.valid) {
      const reader = new FileReader();
      reader.readAsDataURL(this.organizationLogoFile);
      reader.onload = () => {
        console.log('file base64', reader.result);
        this.masterService
      .updateOrg(this.organizationKey, {
        organizationCode: this.form.value.orgCode,
          organizationName: this.form.value.orgName,
          organizationLogoFile: reader.result
      })
        .subscribe((data: any) => {
            if(data.status === 'SUCCESS') {
              this.successToast();
              this.router.navigate(["/secure", "master", "organization", "list"]);
            }
            else {
              this.isSubmitDisabled = false;
              this.errorToast(data.errorMessage);
            }
          }, error => {
            this.isSubmitDisabled = false;
            console.log(error);
            this.errorToast(error.error.errorMessage, 5*1000);
          });
      };
    } else {
      this.isSubmitDisabled = false;
      this.errorToast("");
    }
  }

  async successToast() {
    await this._snackBar.open(
      "Organization details saved successfully.",
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async warningToast() {
    await this._snackBar.open("Please Upload Logo", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}